<template>
  <div>
    <!-- Memorial Dialog -->
    <v-dialog
      v-model="memorialDialog"
      max-width="800"
      persistent
      transition="dialog-transition"
      class="memorial-dialog"
    >
      <v-card class="memorial-card">
        <div class="memorial-overlay"></div>
        <v-card-text class="pa-0">
          <div class="memorial-content">
            <!-- Close Button -->
            <v-btn icon class="close-btn" @click="closeMemorial" color="white">
              <v-icon>mdi-close</v-icon>
            </v-btn>

            <!-- Memorial Image -->
            <div class="memorial-image-wrapper">
              <v-img
                src="12.jpg"
                class="memorial-image"
                aspect-ratio="16/9"
              ></v-img>
              <div class="image-overlay"></div>
            </div>

            <!-- Memorial Text -->
            <div class="memorial-text">
              <div class="ribbon-icon">
                <v-icon size="48" color="white">mdi-ribbon</v-icon>
              </div>
              <h2 class="memorial-title">
                สมเด็จพระนางเจ้าสิริกิต์ พระบรมราชินีนาถ
              </h2>
              <h2 class="memorial-title">พระบรมราชนนนีพันปีหลวง</h2>
              <h2 class="memorial-title">เสด็จสวรรคต</h2>
              <h2 class="memorial-title">ธ สถิตในดวงใจไทยนิรันดร์</h2>
              <div class="memorial-divider"></div>
              <p class="memorial-message">
                ด้วยเกล้าด้วยกระหม่อมขอเดชะ<br />
                ข้าพระพุทธเจ้า คณะผู้บริหาร ข้าราชการ ครูและบุคลากรทางการศึกษา
                และนักศึกษา<br />
                <br />
                สำนักงานคณะกรรมการการอาชีวศึกษา<br />
                <br />
              </p>
              <div class="candle-container">
                <div class="candle">
                  <div class="flame">
                    <div class="flame-inner"></div>
                  </div>
                  <div class="wick"></div>
                  <div class="candle-body"></div>
                </div>
              </div>
              <v-btn class="continue-btn" @click="closeMemorial" text large>
                <v-icon left>mdi-hand-heart</v-icon>
                ดำเนินการต่อ
              </v-btn>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'memorialPage',
  data() {
    return {
      memorialDialog: true, // Show dialog on load
    }
  },

  methods: {
    closeMemorial() {
      this.memorialDialog = false
    },
  },
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Kanit:wght@200;300;400;500;600&display=swap');

* {
  font-family: 'Kanit', sans-serif;
}

/* Memorial Dialog Styles */
.memorial-dialog .v-overlay__content {
  background: rgba(0, 0, 0, 0.95);
}

.memorial-card {
  background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%) !important;
  border-radius: 20px !important;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.8) !important;
  position: relative;
}

.memorial-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(
      circle at 20% 50%,
      rgba(255, 255, 255, 0.03) 0%,
      transparent 50%
    ),
    radial-gradient(
      circle at 80% 50%,
      rgba(255, 255, 255, 0.03) 0%,
      transparent 50%
    );
  pointer-events: none;
  z-index: 1;
}

.memorial-content {
  position: relative;
  z-index: 2;
}

.close-btn {
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 10;
  background: rgba(255, 255, 255, 0.1) !important;
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
}

.close-btn:hover {
  background: rgba(255, 255, 255, 0.2) !important;
  transform: rotate(90deg);
}

.memorial-image-wrapper {
  position: relative;
  overflow: hidden;
}

.memorial-image {
  filter: grayscale(100%) contrast(1.1);
  transition: all 0.5s ease;
}

.image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.3) 0%,
    rgba(0, 0, 0, 0.7) 100%
  );
}

.memorial-text {
  padding: 48px;
  text-align: center;
  color: #ffffff;
}

.ribbon-icon {
  margin-bottom: 24px;
  animation: float 3s ease-in-out infinite;
}

@keyframes float {
  0%,
  100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
}

.memorial-title {
  font-size: 32px;
  font-weight: 300;
  letter-spacing: 2px;
  margin-bottom: 24px;
  color: #ffffff;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.5);
  animation: fadeInUp 0.8s ease-out;
}

.memorial-divider {
  width: 80px;
  height: 2px;
  background: linear-gradient(
    to right,
    transparent,
    rgba(255, 255, 255, 0.5),
    transparent
  );
  margin: 24px auto;
  animation: fadeInUp 1s ease-out;
}

.memorial-message {
  font-size: 18px;
  font-weight: 300;
  line-height: 1.8;
  color: rgba(255, 255, 255, 0.9);
  margin-bottom: 40px;
  animation: fadeInUp 1.2s ease-out;
}

/* Animated Candle */
.candle-container {
  display: flex;
  justify-content: center;
  margin: 40px 0;
  animation: fadeInUp 1.4s ease-out;
}

.candle {
  position: relative;
  width: 40px;
  height: 80px;
}

.flame {
  position: absolute;
  top: -40px;
  left: 50%;
  transform: translateX(-50%);
  width: 20px;
  height: 40px;
  background: linear-gradient(to top, #ff6b00, #ffed4e);
  border-radius: 50% 50% 50% 50% / 60% 60% 40% 40%;
  box-shadow: 0 0 20px #ff6b00, 0 0 40px #ff6b00;
  animation: flicker 2s ease-in-out infinite;
}

.flame-inner {
  position: absolute;
  top: 5px;
  left: 50%;
  transform: translateX(-50%);
  width: 10px;
  height: 20px;
  background: linear-gradient(to top, rgba(255, 255, 255, 0.8), #ffed4e);
  border-radius: 50% 50% 50% 50% / 60% 60% 40% 40%;
  animation: flicker 1.5s ease-in-out infinite alternate;
}

@keyframes flicker {
  0%,
  100% {
    transform: translateX(-50%) scale(1) translateY(0);
    opacity: 1;
  }
  25% {
    transform: translateX(-50%) scale(0.95) translateY(-2px);
    opacity: 0.9;
  }
  50% {
    transform: translateX(-50%) scale(1.05) translateY(2px);
    opacity: 1;
  }
  75% {
    transform: translateX(-50%) scale(0.98) translateY(-1px);
    opacity: 0.95;
  }
}

.wick {
  position: absolute;
  top: -5px;
  left: 50%;
  transform: translateX(-50%);
  width: 3px;
  height: 10px;
  background: #333;
  border-radius: 2px;
}

.candle-body {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 80px;
  background: linear-gradient(to bottom, #f5f5f5, #e0e0e0);
  border-radius: 5px 5px 0 0;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.3);
}

.continue-btn {
  color: rgba(255, 255, 255, 0.9) !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
  padding: 12px 40px !important;
  border-radius: 50px !important;
  transition: all 0.3s ease !important;
  font-weight: 300 !important;
  letter-spacing: 1px !important;
  animation: fadeInUp 1.6s ease-out;
}

.continue-btn:hover {
  background: rgba(255, 255, 255, 0.1) !important;
  border-color: rgba(255, 255, 255, 0.5) !important;
  transform: translateY(-2px);
  box-shadow: 0 5px 20px rgba(255, 255, 255, 0.2);
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Memorial Filter for Main Content */
.memorial-filter {
  position: relative;
}

.memorial-filter::before {
  content: '';
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.05);
  pointer-events: none;
  z-index: 1;
}

.memorial-filter > * {
  position: relative;
  z-index: 2;
}

/* Main Image Memorial Style */
.main-image-wrapper {
  position: relative;
  overflow: hidden;
}

.main-memorial-image {
  filter: grayscale(50%) brightness(0.9);
  transition: all 0.5s ease;
}

.main-memorial-image:hover {
  filter: grayscale(30%) brightness(1);
}

.memorial-badge {
  position: absolute;
  bottom: 20px;
  left: 20px;
  background: rgba(0, 0, 0, 0.8);
  backdrop-filter: blur(10px);
  padding: 12px 24px;
  border-radius: 50px;
  display: flex;
  align-items: center;
  gap: 8px;
  color: white;
  font-size: 14px;
  font-weight: 300;
  letter-spacing: 1px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  animation: fadeInLeft 1s ease-out;
}

@keyframes fadeInLeft {
  from {
    opacity: 0;
    transform: translateX(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

/* Responsive */
@media (max-width: 960px) {
  .memorial-text {
    padding: 32px 24px;
  }

  .memorial-title {
    font-size: 24px;
  }

  .memorial-message {
    font-size: 16px;
  }

  .memorial-badge {
    bottom: 12px;
    left: 12px;
    padding: 8px 16px;
    font-size: 12px;
  }
}
</style>
